import { Stack, Text, styled } from '@/theme/index';

export const PropertyResultsTitle = styled(Text)(({ theme }) => ({
  fontSize: '30px',
  fontWeight: '600',
  color: theme.palette.text.primary,
  paddingTop: '20px',
}));

export const PropertyResultsDisplayAddress = styled('span')(() => ({
  fontWeight: 'bold',
}));

export const NoResultsContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  minHeight: 0,
  padding: '40px 16px',
  marginBottom: '24px',
  textAlign: 'left',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
}));

export const NoResultsSearch = styled(Stack)`
  width: 100%;
  .MuiGrid-container {
    flex-direction: row;
    justify-content: start;
    align-items: start;
  }
`;
